import React, { Component } from 'react';

export default class TooieModal extends Component {
    render() {
        let classNames = "modal" + " " + (this.props.class || "");
        let Header = this.props.hideHeader?"hidden modal-header":"modal-header";
        return (<div className={classNames} id={this.props.id} tabIndex="-1" role="dialog"
                     aria-labelledby="myModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className={Header}>
                        <h4 className="modal-title">{this.props.title}</h4>
                        <button type="button" className="btn btn-success btn-close" data-dismiss="modal"
                                style={{float: "right"}}></button>
                    </div>

                    <div className="modal-body">
                        {this.props.children}
                        {this.props.footer || null}
                    </div>
                </div>
            </div>
        </div>);

    }
}


// WEBPACK FOOTER //
// ./src/react/common/TooieModal.react.js